class GridWithTabs {
    constructor() {
        this.tabs = document.querySelectorAll('.grid-with-tabs__tab');
        this.contentItems = document.querySelectorAll('.grid-with-tabs__content-item');
        this.isTransitioning = false;
        this.init();
    }

    init() {
        this.tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                if (this.isTransitioning) return;
                const tabIndex = tab.getAttribute('data-tab');
                this.switchTab(tabIndex);
            });
        });

        this.tabs[0]?.click();
    }

    async switchTab(tabIndex) {
        this.isTransitioning = true;

        this.tabs.forEach(tab => {
            tab.classList.remove('active');
            if (tab.getAttribute('data-tab') === tabIndex) {
                tab.classList.add('active');
            }
        });

        const currentActive = document.querySelector('.grid-with-tabs__content-item.active');
        const newActive = document.querySelector(`.grid-with-tabs__content-item[data-content="${tabIndex}"]`);

        if (currentActive && newActive) {
            currentActive.classList.remove('active');
            
            await new Promise(resolve => setTimeout(resolve, 500));
            
            newActive.classList.add('active');
        }

        this.isTransitioning = false;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new GridWithTabs();
});
